import React from 'react';
import { FileText, CheckCircle2 } from 'lucide-react';

export function VirtualAdoptionBenefits() {
  return (
    <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
          <FileText className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
        </div>
        <h2 className="card-title">
          Jak możesz pomóc?
        </h2>
      </div>
      
      <div className="space-y-4">
        <ul className="space-y-4 body-medium">
          <li className="list-item">
            <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" aria-hidden="true" />
            <div>
              <strong className="block label-large">
                Wsparcie finansowe
              </strong>
              <span>Regularne wpłaty w dowolnej kwocie</span>
            </div>
          </li>
          <li className="list-item">
            <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
            <div>
              <strong className="block label-large">
                Karma
              </strong>
              <span>Regularne dostarczanie karmy dla zwierzaka</span>
            </div>
          </li>
          <li className="list-item">
            <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
            <div>
              <strong className="block label-large">
                Akcesoria
              </strong>
              <span>Zabawki, legowiska i inne potrzebne rzeczy</span>
            </div>
          </li>
          <li className="list-item">
            <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
            <div>
              <strong className="block label-large">
                Promocja
              </strong>
              <span>Udostępnianie informacji o zwierzaku w mediach społecznościowych</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}